<template>
  <el-form-item>
    <el-autocomplete
      v-model="customerName"
      :fetch-suggestions="queryCustomerName"
      @select="handleSelectCustomerName"
      size="small"
      :placeholder="$t('menu.customers')"
      @blur="customerNameBlur"
    >
    </el-autocomplete>
    <!-- <el-select
      size="small"
      v-model="customerId"
      filterable
      remote
      :remote-method="queryCustomerName"
      :loading="customersLoading"
      :clearable="true"
      :placeholder="$t('menu.customers')"
      @change="handleSelectCustomerName"
    >
      <el-option
        v-for="customer in customers"
        :key="customer.id"
        :label="customer.name"
        :value="customer.id"
      />
    </el-select> -->
  </el-form-item>
</template>

<script>
import Customer from "@/api/customer.js";

export default {
  props: {
    // eslint-disable-next-line vue/require-default-prop
    value: Object,
    fieldId: {
      type: String,
      default: "",
    },
    fieldName: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      customers: [],
      customersLoading: false,
      customerName: null,
      customerId: null,
    };
  },
  methods: {
    queryCustomerName(queryString, cb) {
      const self = this;
      self.customerId = null;
      if (queryString == null || queryString.length < 1) {
        Customer.findAllJy().then(function (res) {
          let ps = res.data;
          ps.forEach((p) => (p.value = p.name));
          self.customers = ps;
          cb(self.customers);
        });
        return;
      }
      Customer.vagueFindByName({ name: queryString }).then(function (res) {
        let ps = res.data;
        ps.forEach((p) => (p.value = p.name));
        self.customers = ps;
        cb(self.customers);
      });
      if (queryString == null || queryString.length < 1) {
        return;
      }
      // this.customersLoading = true;
      // Customer.vagueFindByName({ name: queryString }).then(function (res) {
      //   self.customers = res.data;
      //   self.customersLoading = false;
      // });
    },
    handleSelectCustomerName(item) {
      // console.log("====", item);
      this.customerName = item.name;
      this.customerId = item.id;
      this.value[this.fieldId] = this.customerId;
      this.value[this.fieldName] = this.customerName;
      // this.value[this.field] = this.customerId;
    },
    customerNameBlur() {
      this.value[this.fieldId] = this.customerId;
      this.value[this.fieldName] = this.customerName;
    },
  },
};
</script>
